import React, { createContext, useContext, useEffect, useState } from "react";

import { disconnectSocket, initializeSocket } from "./initializeSocket";
import { registerNotificationEvents } from "./socketEvents";

const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [notify, setNotify] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const _id = localStorage.getItem("_id");
    if (!token) return;

    const s = initializeSocket(token, _id);
    setSocket(s);

    registerNotificationEvents(s, {
      onNewNotification: () => {
        
        setNotify((prev) => !prev);
      },
    });

    return () => {
      disconnectSocket();
    };
  }, []);

  return (
    <SocketContext.Provider value={{ socket, notify, setNotify }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
